// src/components/gridpagefunction/addEmpty.js
import * as Three from 'three';
import {
  update_assets_data,
  selected_object,
} from '../../../redux/Slice/gridSlice';

export const EmptyObject = ({
  scene,
  dispatch,
  selectObjectInScene,
  setSelectedObjectState,
  assets_data, // Required to get current empty array
}) => {
  const newEmptyId = `Empty_${Date.now()}`;
  const emptyObj = new Three.Object3D();
  emptyObj.name = newEmptyId;
  scene.add(emptyObj);

  const emptyItem = {
    _id: newEmptyId,
    id: newEmptyId,
    name: `Empty_${newEmptyId.split('_')[1]}`,
    type: 'Object3D',
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [1, 1, 1],
  };

  // Get current empty array and append new item
  const currentEmpty = assets_data?.empty || [];
  const newEmptyArray = [...currentEmpty, emptyItem];

  // Dispatch full array for empty type
  dispatch(update_assets_data({ type: 'empty', data: newEmptyArray }));

  // Select the new empty object
  dispatch(selected_object(emptyObj));
  selectObjectInScene(newEmptyId);
  setSelectedObjectState(emptyObj);
};
